export default {
  fr: {
    contributions: (count: number) =>
      count === 1 ? 'contribution' : 'contributions',
  },
  en: {
    contributions: (count: number) =>
      count === 1 ? 'contribution' : 'contributions',
  },
  de: {
    contributions: (count: number) => (count === 1 ? 'Beitrag' : 'Beiträge'),
  },
  es: {
    contributions: (count: number) =>
      count === 1 ? 'contribución' : 'contribuciones',
  },
  'pt-br': {
    contributions: (count: number) =>
      count === 1 ? 'contribuição' : 'contribuições',
  },
}
